/**
 * 店中店修正传票查询
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const api = {
    //页面初始化
    init() {
      return axios.get(`${Vue.prototype.$base.API_PATH}/in-shop/inittemplate`);
    },
    //检索数据
    search(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/in-shop` ,{ params: params});
    },
  //转账通知单查询-店中店修正传票查询-根据传票号码得到店中店修正传票明细结果集
  detail(poNum) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/in-shop/`+poNum );
  },
}

export default api;



// WEBPACK FOOTER //
// ./src/api/inShop.js